


























import { Component, Prop, Mixins } from "vue-property-decorator";
import { DelegateObjectTypes } from "@/data/enums/delegates";
import CProdInjectorMixin from "@/mixins/cProdInjectorMixin";

@Component({
  components: {
    "delegates-provider": () =>
      import("@/components/app/global/delegates/delegatesProvider.vue"),
    "delegates-table": () =>
      import("@/components/app/global/delegates/delegatesTable.vue")
  }
})
export default class CProdDelegatesComponent extends Mixins(
  CProdInjectorMixin
) {
  // Props
  @Prop({
    required: true,
    validator: tag =>
      ["u-aside", "u-section-box", "u-contextualise"].includes(tag)
  })
  public readonly tag!: string;

  // Computed

  public get isVisible() {
    return !this.cProdData.isDelegatedAccess;
  }

  public get brandName() {
    return this.cProdData.contract?.brand?.name;
  }

  public get providerBindings() {
    return {
      objectType: DelegateObjectTypes.CONTRACT_PRODUCT,
      objectId: this.cProdData.contractProductId
    };
  }
}
